import { t } from 'i18next'
import { useState } from 'react'

import { Divider } from '@/components/Divider/Divider.component'
import {
  ResponsiveModal,
  ResponsiveModalClose,
  ResponsiveModalContent,
  ResponsiveModalDescription,
  ResponsiveModalHeader,
  ResponsiveModalTitle,
} from '@/components/ResponsiveModal/ResponsiveModal'
import { Button } from '@/components/ui/button'

export const PopupSearchForm = () => {
  const [open, setOpen] = useState(true)

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <ResponsiveModal open={open} onOpenChange={setOpen}>
      <ResponsiveModalContent
        className="max-w-3xl bg-baseColor p-6 flex flex-col gap-3"
        side="bottom"
      >
        <ResponsiveModalHeader>
          <ResponsiveModalTitle className="text-neutralColor text-[32px] font-medium">
            {t('setup.popup.title')}
          </ResponsiveModalTitle>
          <ResponsiveModalDescription className="text-neutralColor80 text-base font-normal">
            {t('setup.popup.description')}
          </ResponsiveModalDescription>
        </ResponsiveModalHeader>

        <div className="flex flex-col gap-6">
          <div className="flex flex-col gap-2">
            <h3 className="text-neutralColor text-xl font-medium">
              {t('setup.popup.howToSeeTitle')}
            </h3>

            <p className="text-neutralColor80 text-sm font-normal">
              {t('setup.popup.howToSeeBefore')}{' '}
              <strong>{t('setup.popup.public')}</strong>{' '}
              {t('setup.popup.howToSeeBetween')}{' '}
              <strong>{t('setup.popup.private')}</strong>{' '}
              {t('setup.popup.howToSeeAfter')}
            </p>
          </div>
          <Divider />
          <div className="flex flex-col gap-2">
            <h3 className="text-neutralColor text-xl font-medium">
              {t('setup.popup.whyTitle')}
            </h3>
            <p className="text-neutralColor80 text-sm font-normal">
              {t('setup.popup.whyText')}
            </p>
          </div>
          <Divider />

          <div className="flex flex-col gap-2">
            <h3 className="text-neutralColor text-xl font-medium">
              {t('dashboard.home.companiesCanSee.whatYouSeeTitle')}
            </h3>
            <div className="flex flex-col gap-2">
              <div className="flex flex-col gap-1">
                <p className="text-neutralColor80 text-sm font-normal">
                  •{' '}
                  <span className="font-semibold">
                    {t('dashboard.home.companiesCanSee.completePublic')}
                  </span>{' '}
                  {t(
                    'dashboard.home.companiesCanSee.completePublicDescription',
                  )}
                </p>
                <p className="text-neutralColor80 text-sm font-normal">
                  •{' '}
                  <span className="font-semibold">
                    {t('dashboard.home.companiesCanSee.standardPrivate')}
                  </span>{' '}
                  {t(
                    'dashboard.home.companiesCanSee.standardPrivateDescription',
                  )}
                </p>
                <p className="text-neutralColor80 text-sm font-normal">
                  •{' '}
                  <span className="font-semibold">
                    {t('dashboard.home.companiesCanSee.skipped')}
                  </span>{' '}
                  {t('dashboard.home.companiesCanSee.skippedDescription')}
                </p>
              </div>
            </div>
          </div>
          <Divider />
        </div>

        <div className="flex justify-end mt-2">
          <ResponsiveModalClose asChild>
            <Button
              onClick={handleClose}
              className="h-[46px] px-5 py-3 rounded-3xl"
            >
              {t('dashboard.home.companiesCanSee.gotIt')}
            </Button>
          </ResponsiveModalClose>
        </div>
      </ResponsiveModalContent>
    </ResponsiveModal>
  )
}
